<template>
  <Transition name="offline">
    <div v-if="!isOnline" class="offline-banner">
      <span class="offline-icon">📡</span>
      <span>网络已断开，部分功能可能不可用</span>
      <span v-if="offlineQueueCount > 0" class="queue-badge">
        {{ offlineQueueCount }} 条待同步
      </span>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const isOnline = ref(navigator.onLine)
const offlineQueueCount = ref(0)

function updateOnline() {
  isOnline.value = navigator.onLine
}

function handleSWMessage(event: MessageEvent) {
  if (event.data?.type === 'OFFLINE_QUEUE_COUNT') {
    offlineQueueCount.value = event.data.count
  }
}

onMounted(() => {
  window.addEventListener('online', updateOnline)
  window.addEventListener('offline', updateOnline)
  navigator.serviceWorker?.addEventListener('message', handleSWMessage)
})

onUnmounted(() => {
  window.removeEventListener('online', updateOnline)
  window.removeEventListener('offline', updateOnline)
  navigator.serviceWorker?.removeEventListener('message', handleSWMessage)
})
</script>

<style scoped>
.offline-banner {
  position: fixed; top: 0; left: 0; right: 0; z-index: 9999;
  background: #ff4d4f; color: white; padding: 8px 20px;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  font-size: 14px; box-shadow: 0 2px 8px rgba(255,77,79,0.3);
}

.offline-icon { font-size: 18px; }

.queue-badge {
  background: rgba(255,255,255,0.25); padding: 2px 8px;
  border-radius: 10px; font-size: 12px;
}

.offline-enter-active, .offline-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.offline-enter-from, .offline-leave-to {
  transform: translateY(-100%); opacity: 0;
}
</style>
